type Props = {
  title: string;
};

export const Header = (props: Props) => {
  const { title } = props;

  return (
    <div className="flex-col-view flex-center relative w-[1280px] h-[100px]">
      {/* タイトル: 568px幅で中央配置 */}
      <div className="flex-col-view justify-end w-[568px] h-full">
        <div className="w-full bg-white border-solid border-x-0 border-y-[4px] border-red-80">
          <p className="text !text-[42px] text-textcolor-black !leading-[42px] !mb-[3px]">
            {title}
          </p>
        </div>
      </div>
    </div>
  );
};
